/**
 * 模組頁面代碼 :
 * 頁面說明 : 功能表頁面
 * @module features/main-frame/components/Sidebar.jsx
 */

// ----- import from npm modules -----
import {useNavigate, useLocation, NavLink} from 'react-router-dom';

// ----- import from base components -----
import {React, PropTypes, BaseComponent, bindActionCreators, connect, withTranslation} from '../../../components/BaseComponent';
import DOMPurify from 'dompurify';

// ----- import from local actions -----
import {logout} from '../../../redux/actions/AuthActions';
import enumList from '../../../utils/enumList';

const Sidebar = ({
  className = null,
  forwardedRef = null,
  userPermissions = [],
  username = '',
  email = '',
  roleName = '',
  onLogout,
  onNavigate,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getPermittedPage = (moduleName) => {
    // Check if has userPermissions array
    if (!Array.isArray(userPermissions)) {
      console.error('userPermissions is not an array:', userPermissions);
      return;
    }

    let moduleContent = null;

    userPermissions.forEach((permission) => {
      if (permission.moduleName === moduleName) {
        moduleContent = permission.children.map((child, index) => {
          if (child.flgRead === 1) {
            const navigatePath = `/module/${child.navigatePath}`.replace(/\/+/g, '/');
            if (child.defaultPage === 1) {
              return (
                <li className="nav-item" key={index}>
                  <NavLink className="nav-link" aria-current="page" to={navigatePath}>
                    {child.moduleName}
                  </NavLink>
                </li>
              );
            } else {
              return (
                <li className="nav-item " key={index}>
                  <NavLink className="nav-link " aria-current="page" to={navigatePath}>
                    <svg className="nav__icon nav__icon--sidebar me-2" style={{color: 'var(--bs-indigo)'}} aria-hidden="true">
                      <use href={`#${child.iconStyle}`}></use>
                    </svg>
                    {child.moduleName}
                  </NavLink>
                </li>
              );
            }
          }
          return null;
        });
      }
    });

    return moduleContent;
  };

  const handleLogout = (e) => {
    e.preventDefault();
    onLogout().then(() => {
      // Clear userPermissions state
      userPermissions = [];
      onNavigate('/Login');
    });
  };

  return (
    <div id="sidebar-container" className="sidebar">
      <div className="offcanvas-lg offcanvas-end" id="offcanvasNav">
        <nav className="nav nav--sidebar navbar small">
          <div className="container-fluid">
            <div className="accordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidebar__nav__menu-01"
                    aria-expanded="true"
                    aria-controls="sidebar__nav__menu-01"
                  >
                    {enumList.menuList.A}
                  </button>
                </h2>
                <div id="sidebar__nav__menu-01" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    <ul className="navbar-nav">{getPermittedPage(enumList.menuList.A)}</ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidebar__nav__menu-02"
                    aria-expanded="true"
                    aria-controls="sidebar__nav__menu-02"
                  >
                    {enumList.menuList.B}
                  </button>
                </h2>
                <div id="sidebar__nav__menu-02" className="accordion-collapse collapse show ">
                  <div className="accordion-body">
                    <ul className="navbar-nav">{getPermittedPage(enumList.menuList.B)}</ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidebar__nav__menu-03"
                    aria-expanded="true"
                    aria-controls="sidebar__nav__menu-03"
                  >
                    {enumList.menuList.C}
                  </button>
                </h2>
                <div id="sidebar__nav__menu-03" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    <ul className="navbar-nav">{getPermittedPage(enumList.menuList.C)}</ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidebar__nav__menu-04"
                    aria-expanded="true"
                    aria-controls="sidebar__nav__menu-04"
                  >
                    {enumList.menuList.D}
                  </button>
                </h2>
                <div id="sidebar__nav__menu-04" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    <ul className="navbar-nav">{getPermittedPage(enumList.menuList.D)}</ul>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidebar__nav__menu-05"
                    aria-expanded="true"
                    aria-controls="sidebar__nav__menu-05"
                  >
                    {enumList.menuList.E}
                  </button>
                </h2>
                <div id="sidebar__nav__menu-05" className="accordion-collapse collapse show">
                  <div className="accordion-body">
                    <ul className="navbar-nav">{getPermittedPage(enumList.menuList.E)}</ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <footer className="d-flex justify-content-between align-content-center mt-auto pt-3 border-top">
          <div className="d-flex flex-column justify-content-center gap-1">
            <div className="fs-6">{username}</div>
            <div className="small text-secondary">{email}</div>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <a className="btn btn-link" href="admin-1.0-log-in.html" onClick={handleLogout}>
              <svg className="nav__icon nav__icon--sidebar" style={{color: 'var(--bs-indigo)'}} aria-hidden="true">
                <use href="#ico-log-out"></use>
              </svg>
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  forwardedRef: PropTypes.object,
  userPermissions: PropTypes.array,
  username: PropTypes.string,
  roleName: PropTypes.string,
  email: PropTypes.string,
  onLogout: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
};

/**
 *
 */
function mapStateToProps(state) {
  return {
    userPermissions: JSON.parse(state.access.userPermissions),
    username: state.auth.username,
    roleName: state.auth.roleName,
    email: state.auth.email,
  };
}

/**
 *
 */
function mapDispatchToProps(dispatch) {
  return {
    onLogout: () => {
      return dispatch(logout());
    },
  };
}

const ConnectedSidebar = connect(mapStateToProps, mapDispatchToProps)(Sidebar);

/**
 *
 */
export default function SidebarWrapper(props) {
  const navigate = useNavigate();
  return <ConnectedSidebar {...props} onNavigate={(path) => navigate(path)} />;
}
